import type { InputHTMLAttributes, ReactNode } from 'react'
import styles from './Checkbox.module.css'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode
}

export function Checkbox({ label, className, disabled, ...props }: CheckboxProps) {
  const inputClasses = [styles.checkbox, className].filter(Boolean).join(' ')

  const input = <input type="checkbox" className={inputClasses} disabled={disabled} {...props} />

  if (!label) {
    return input
  }

  const labelClasses = [styles.label, disabled && styles.disabled].filter(Boolean).join(' ')

  return (
    <label className={labelClasses}>
      {input}
      {/* One box for the words, so a label with a link in it reads as a
          sentence instead of each piece becoming its own flex column. */}
      <span className={styles.text}>{label}</span>
    </label>
  )
}
